export type MobilePlatform = "ios" | "android" | "web";
export function mobilePlatform(
  userAgent: string,
  platform: string,
  touchPoints: number,
): MobilePlatform {
  if (
    /iPhone|iPad|iPod/i.test(userAgent) ||
    (platform === "MacIntel" && touchPoints > 1)
  )
    return "ios";
  return /Android/i.test(userAgent) ? "android" : "web";
}
